import SecureRequest from "utils/securerequest";
/** @typedef {import("api/types/appointments").Appointment} Appointment */

/**
 * @deprecated
 * This function has been deprecated, in favor of cancelVideoCallAsync
 * to be used with react-query.
 */
export function* cancelVideoCall(videoCall) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return yield Request.put(`/v3/appointments/${videoCall.id}/cancel`, videoCall);
}

export async function cancelVideoCallAsync(videoCall) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.put(`/v3/appointments/${videoCall.id}/cancel`, videoCall);
}

/**
 * @deprecated
 * This function has been deprecated, in favor of rescheduleVideoCallAsync
 * to be used with react-query.
 */
export function* rescheduleVideoCall(videoDetails) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return yield Request.put(`/v3/appointments/${videoDetails.videoId}/reschedule`, videoDetails);
}

export async function rescheduleVideoCallAsync(videoDetails) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.put(`/v3/appointments/${videoDetails.videoId}/reschedule`, videoDetails);
}

export function* getVideoChatInfo({ id, isOtherServices }) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return yield Request.get(`/v3/appointments/${id}?isNonVideo=${isOtherServices}`);
}

/**
 * @deprecated
 * This function has been deprecated, in favor of scheduleVideoCallAsync
 * to be used with react-query.
 */
export function* scheduleVideoCall(videoDetails) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return yield Request.post(`/v3/appointments/${videoDetails.clientId}/schedule`, videoDetails);
}

export async function scheduleVideoCallAsync(videoDetails) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.post(`/v3/appointments/${videoDetails.clientId}/schedule`, videoDetails);
}

export async function getRescheduleOptions(id) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.get(`/v3/appointments/${id}/reschedule-options`);
}

export async function getProposedAppointments() {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.get(`/v3/appointments/proposed`);
}

export async function refreshProposedAppointments({ userId }) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  console.log("Refreshing proposed appointments for user:", userId);
  return await Request.put(`/v3/appointments/refresh-proposed/${userId}`);
}

/**
 * Get the appointment info
 * @param {string} id - The appointment id
 * @returns {Promise<{data: Appointment}>} The appointment info
 */
export async function getAppointmentInfo(id) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.get(`/v3/appointments/${id}`);
}

export async function getCancellationReasons({ recurringOnly = false } = {}) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const query = recurringOnly ? "?recurringOnly=true" : "";
  return await Request.get(`/v3/appointments/cancellation-reasons${query}`);
}
